import { render, staticRenderFns } from "./SidebarMenuLeadObserver.vue?vue&type=template&id=64e545e2&"
import script from "./SidebarMenuLeadObserver.vue?vue&type=script&lang=js&"
export * from "./SidebarMenuLeadObserver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports